class BlogAPI {
	constructor() {
		const wordpressURL = 'vibesniper.wordpress.com';
		this.baseURL = `https://public-api.wordpress.com/wp/v2/sites/${wordpressURL}/`;
	}

	static handleErrors(response) {
		if (!response || !response.ok) {
			throw Error(response.statusText);
		}

		return response;
	}

	get(endpoint) {
		return new Promise((resolve, reject) => {
			fetch(`${this.baseURL}${endpoint}`)
				.then(response => this.constructor.handleErrors(response))
				.then(response => response.json())
				.then(data => resolve(data))
				.catch(error => reject(error));
		});
	}
}

export default new BlogAPI();
